// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { CStamp } from '../../SagaSchema/CStamp';
import * as SagaSchema from '../../SagaSchema';
import { Guid, GuidTools } from '@models/guid';

export abstract class CStampComJob_abstract extends CStamp {
  static $t: string = 'SagaSchema.CStampComJob';
  $t: string = 'SagaSchema.CStampComJob';

  public static GetMembers(): string[] {
    return ['ComJobObjId', 'ComJobName', 'Text', 'ComJobStatus'].concat(CStamp.GetMembers());
  }

  public GetMembers(): string[] {
    return CStampComJob_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ComJobObjId: Guid = GuidTools.Empty;
  public ComJobName: string = '';
  public Text: string = '';
  public ComJobStatus: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
